import { toast } from "react-toastify";
import { getMethod, postMethod, putMethod } from "../../api-service/api-service";
import {
    setTechniques,
    setSelectedTechnique,
    setLoading,
    setError,
    setTotalPages,
    setTotalTechniques
} from "./techniquesSlice";

// Fetch all techniques with filters/pagination
export const fetchAllTechniquesAction = (params) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const queryString = params ?
            Object.keys(params)
                .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
                .map(key => `${key}=${encodeURIComponent(params[key])}`)
                .join('&')
            : '';
        const url = `/techniques${queryString ? `?${queryString}` : ''}`;
        const response = await getMethod(url);

        if (response.success === true) {
            dispatch(setTechniques(response.techniques));
            dispatch(setTotalPages(response.totalPages));
            dispatch(setTotalTechniques(response.totalTechniques));
        } else {
            toast.error(response?.message || "Failed to fetch techniques");
        }
        dispatch(setLoading(false));
    } catch (error) {
        console.log("Error: ", error);
        dispatch(setLoading(false));
    }
};

// Fetch technique by ID
export const fetchTechniqueByIdAction = (id) => async (dispatch) => {
    try {
        const response = await getMethod(`/techniques/${id}`);
        if (response.success === true) {
            dispatch(setSelectedTechnique(response.technique));
            toast.success("Technique Fetched Successfully");
        } else {
            toast.error(response?.message || "Failed to fetch technique");
        }
    } catch (error) {
        console.log("Error: ", error);
    }
};

// Add new technique
export const addNewTechniqueAction = (data) => async (dispatch) => {
    try {
        const response = await postMethod('/techniques', data);
        if (response.success === true) {
            dispatch(setSelectedTechnique(response.technique));
            toast.success("Technique Created Successfully");
        } else {
            toast.error(response?.message || "Failed to create technique");
        }
        return response;
    } catch (error) {
        console.log("Error: ", error);
    }
};

// Update technique
export const updateTechniqueAction = (id, data) => async (dispatch) => {
    try {
        const response = await putMethod(`/techniques/${id}`, data);
        if (response.success === true) {
            dispatch(setSelectedTechnique(response.technique));
            toast.success("Technique Updated Successfully");
        } else {
            toast.error(response?.message || "Failed to update technique");
        }
        return response;
    } catch (error) {
        console.log("Error: ", error);
    }
};